
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { EPermissionActions } from '@/model/EPermissionActions';
import { IAuthUserData } from '@/store/modules/authModule';
import { PermissionHelper } from '@/helpers/PermissionHelper';

const authModule = namespace('authModule');

interface NavTab {
  route: string;
  icon: string;
  labelKey: string;
  label?: string;
  visible: boolean;
}

// Top nav of the orders section (single orders / subscriptions), same format as UserNav
@Component({ name: 'OrderSectionTabs' })
export default class OrderSectionTabs extends Vue {
  @authModule.Getter('userData')
  protected authUser!: IAuthUserData;

  // Computed (not a class property) so the permission checks see the store getters and stay reactive
  get allTabs(): NavTab[] {
    return [
      { route: 'orderList', icon: 'mdi-package-variant-closed', labelKey: 'menu.orders.single',
        visible: this.$canAction(EPermissionActions.ACTION_ORDERS) },
      { route: 'subscriptionList', icon: 'mdi-refresh-auto', labelKey: 'menu.subscriptions.title',
        visible: PermissionHelper.canViewSubscriptions(this.authUser) },
    ];
  }

  get visibleTabs(): NavTab[] {
    return this.allTabs
      .filter(tab => tab.visible)
      .map(tab => ({
        ...tab,
        label: this.$t(tab.labelKey) as string,
      }));
  }

  get activeTabIndex(): number {
    const currentRoute = this.$route.name;
    return this.visibleTabs.findIndex(tab => tab.route === currentRoute);
  }

  isActive(routeName: string): boolean {
    return this.$route.name === routeName;
  }
}
